import { useState, useEffect, useRef } from 'react';
import { HiArrowRight } from 'react-icons/hi';
import HeroParticles from './components/HeroParticles';
import ShortsSlider from './components/ShortsSlider';
import SocialsSection from './components/SocialsSection';
import './App.css';

const vaughnGto = `${process.env.PUBLIC_URL || ''}/vaughngto.jpg`;

function Coaching() {
  const [scrolled, setScrolled] = useState(false);
  const [visibleSections, setVisibleSections] = useState({ hero: true });
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: '',
    contact: '',
    stakes: '',
    goals: '',
  });
  const sectionRefs = useRef({});

  useEffect(() => {
    document.title = 'VaughnGTO | Poker Coaching';
    const icon = document.querySelector('link[rel="icon"]');
    const apple = document.querySelector('link[rel="apple-touch-icon"]');
    const prevIcon = icon ? { href: icon.href, type: icon.type } : null;
    const prevApple = apple ? apple.href : null;
    if (icon) {
      icon.href = `${process.env.PUBLIC_URL || ''}/vaughngto.jpg`;
      icon.type = 'image/jpeg';
    }
    if (apple) apple.href = `${process.env.PUBLIC_URL || ''}/vaughngto.jpg`;
    return () => {
      document.title = 'ClubGTO | Online Poker Community';
      if (icon && prevIcon) {
        icon.href = prevIcon.href;
        icon.type = prevIcon.type;
      }
      if (apple && prevApple) apple.href = prevApple;
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => ({
              ...prev,
              [entry.target.id]: true,
            }));
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    Object.values(sectionRefs.current).forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  const registerRef = (id) => (el) => {
    sectionRefs.current[id] = el;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="landing-page">
      <div className="bg-gradient-top" />
      <div className="bg-gradient-bottom" />

      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <a href="/" className="nav-logo">
            <img src={vaughnGto} alt="VaughnGTO" className="nav-logo-img coaching-avatar" />
          </a>
          <a href="#request" className="nav-cta">Request Coaching</a>
        </div>
      </nav>

      <section className="hero coaching-hero" id="hero" ref={registerRef('hero')}>
        <HeroParticles showLogos={false} />
        <div className="hero-content coaching-hero-content">
          <div className="animate-in">
            <div className="hero-badge">
              <span className="hero-badge-dot" />
              1-on-1 Coaching
            </div>
          </div>

          <h1 className="animate-in delay-1 coaching-hero-title">
            GET COACHING<br />
            FROM <span className="highlight">VAUGHNGTO</span>
          </h1>

          <p className="hero-subtitle animate-in delay-2 coaching-hero-copy">
            Work directly with Vaughn on your game. Fill out the form below
            and he&rsquo;ll follow up with next steps.
          </p>
        </div>

        <ShortsSlider />

        <div className="hero-content coaching-hero-content">
          <div className="coaching-form-wrap animate-in delay-3" id="request">
            {submitted ? (
              <div className="coaching-form coaching-form-success">
                <div className="coaching-success-title">Request Sent</div>
              </div>
            ) : (
              <form className="coaching-form" onSubmit={handleSubmit}>
                <div className="coaching-form-header">
                  <div className="section-label">Quick Request</div>
                  <h2 className="coaching-form-title">Tell Vaughn about your game</h2>
                </div>

                <label className="coaching-field">
                  <span>Name</span>
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Your name"
                    required
                  />
                </label>

                <label className="coaching-field">
                  <span>Telegram, email, or Discord</span>
                  <input
                    type="text"
                    name="contact"
                    value={form.contact}
                    onChange={handleChange}
                    placeholder="@username or email"
                    required
                  />
                </label>

                <label className="coaching-field">
                  <span>Stakes / experience</span>
                  <input
                    type="text"
                    name="stakes"
                    value={form.stakes}
                    onChange={handleChange}
                    placeholder="e.g. NL50, live 1/3, beginner"
                  />
                </label>

                <label className="coaching-field">
                  <span>What do you want to work on?</span>
                  <textarea
                    name="goals"
                    value={form.goals}
                    onChange={handleChange}
                    placeholder="Short version is fine, leaks, study plan, live vs online, etc."
                    rows={4}
                    required
                  />
                </label>

                <button type="submit" className="btn-primary coaching-submit">
                  Send Request
                  <HiArrowRight />
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      <SocialsSection
        visible={visibleSections.socials}
        sectionRef={registerRef('socials')}
      />

      <footer className="footer">
        <div className="container">
          <div className="footer-brand">
            <img src={vaughnGto} alt="VaughnGTO" className="footer-logo coaching-avatar" />
          </div>
          <div className="footer-text">
            &copy; {new Date().getFullYear()} VaughnGTO. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Coaching;
